import styled from 'styled-components'

const LengthLabel = styled.p`
  position: absolute;
  right: 45%;
  top: 47%;
`

export default LengthLabel
